import { defineStore } from "pinia";
import { useUserStore } from "../../../../Stores/User";
import { getPreferredAssignerProfileId } from "../../../../Composables/useAssignOnBehalfOf";

export const useTeam = defineStore("TeamStore", {
    state: () => ({
        team_list: [],
        assigned: null,
        assigner: null,
        currently_assigned: null,
        currently_assigner: null,
        assigned_check_btn: false,
        create_variant: false,
        toggle_create: true,
        new_variant_name: null,
        are_users_invited: false,
        group_image: null,
        temp_group_invitable_profile: [],
    }),
    getters: {
        // is_comment_tab: (state) => state.tab === 'comment'

        get_checked_invitees: (state) => {
            let members = state.team_list.filter((member) => {
                if (member.checked === true) {
                    if (!member.checkedOrder) {
                        member.checkedOrder = Date.now();
                    }
                    return true;
                }
            });

            const current_profile_id = useUserStore().getCurrentUserProfileId();
            const current_user = members.find(
                (member) => member.id == current_profile_id,
            );
            if (current_user) {
                current_user.checkedOrder = 1;
            }

            return members.sort(function (a, b) {
                return a.checkedOrder - b.checkedOrder;
            });
        },
        is_assigned_id_changed: (state) => {
            const assignee_changed =
                state.currently_assigned !== state.assigned;

            const original_assigner = state.currently_assigner ?? null;
            const current_assigner = state.assigner ?? null;
            const assigner_changed =
                original_assigner === null && current_assigner === null
                    ? false
                    : Number(original_assigner) !== Number(current_assigner);

            return assignee_changed || assigner_changed;
        },
    },
    actions: {
        resetCheckedInvitees() {
            this.team_list.forEach((member) => {
                member.checked = false;
                if (member.checkedOrder) {
                    delete member.checkedOrder;
                }
            });
        },
        setAssigned(val) {
            console.log("setAssigned", val);
            this.assigned = val;
        },
        setAssigner(val) {
            this.assigner = val ?? null;
        },
        setOriginalAssigned(val) {
            this.currently_assigned = val;
        },
        setOriginalAssigner(val) {
            this.currently_assigner = val ?? null;
        },

        resetAssigned() {
            this.setAssigned(null);
        },
        resetAssigner() {
            this.setAssigner(null);
        },
        resetOriginalAssigner() {
            this.setOriginalAssigner(null);
        },

        setAssignedCheckBtn(val) {
            this.assigned_check_btn = val;
        },

        setCreateVariant(val) {
            this.create_variant = val;
        },

        setToggleCreate(val) {
            this.toggle_create = val;
        },

        setNewVariantName(val) {
            this.new_variant_name = val;
        },

        resetNewVariantName() {
            this.setNewVariantName(null);
        },

        setAreUsersInvited(val) {
            this.are_users_invited = val;
        },

        setTeamList(val) {
            this.team_list = val;
        },

        assignedTo(member, assignerProfileId = null) {
            const resolvedAssignerId =
                assignerProfileId ??
                getPreferredAssignerProfileId(
                    member?.potential_assigners ?? [],
                ) ??
                useUserStore().getCurrentUserProfileId();

            if (!this.assigned || this.assigned != member?.id) {
                this.setAssigned(member?.id);
                this.setAssigner(resolvedAssignerId);
                member.checked = true;
                if (
                    useUserStore().getCurrentUserProfileId() != member.id &&
                    !member.checkedOrder
                ) {
                    member.checkedOrder = Date.now();
                }
                return;
            }

            if (assignerProfileId != null) {
                this.setAssigner(resolvedAssignerId);
                return;
            }

            this.setAssignedCheckBtn(false);
            this.resetAssigned();
            this.resetAssigner();
        },

        checkGroupItem(groups, members) {
            groups.getOtherParticipants().forEach((group_member) => {
                const user = members.find(
                    (invUser) => invUser.id == group_member.id,
                );

                if (!user) return;

                groups.checked
                    ? user.checked
                        ? (user.count += 1)
                        : (user.count = 1)
                    : (user.count -= 1);
                user.count > 0 ? (user.checked = true) : (user.checked = false);
            });
        },

        uncheckGroupsWhenMemberisUnchecked(groups) {
            groups.forEach((item) => {
                if (item.checked) {
                    item.participants.forEach((participant) => {
                        if (
                            !this.get_checked_invitees.find(
                                (checked) => checked.id === participant.id,
                            )
                        ) {
                            item.checked = false;
                            return;
                        }
                    });
                }
            });
        },
    },
});
